import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { navigateTo } from 'src/common/navigation';
import { captureLogout } from 'src/common/analytics';

//URL fo API request
export const Axios = axios.create({
  // baseURL: 'https://arkapi.inabia.com/api', //ark production
  baseURL: 'https://api.mlrcsolution.com/api', // ark production new2 (09-feb-2026)
  // baseURL: 'https://arkapistag.inabia.com/api', //ark staging
 
  // baseURL: 'https://arkapistag.inabia.com/api', //ark staging

  headers: {
    'Content-type': 'application/json'
  }
});

//Project Name
export const projectName = {
  Path: 'Ark' //Ark
};

export const S3bucket = {};

export const Segment = {
  tracking: true //true or false
};

//Check for file statuses
export const AxiosNetwork = axios.create({
  baseURL: 'https://inabia.com/inabia-ai-crobjob',
  headers: {
    'Content-type': 'application/json'
  }
});

//Initialize user login parameters for API calls
Axios.interceptors.request.use((config) => {
  const userId = localStorage.getItem('userId');
  let langId = '2';
  let langType = localStorage.getItem('languageType');
  console.log('langType Shery ==> ', langType)
  if (langType == 'null') {
    langId = '2';
  } else if (langType) {
    langId = langType;
  }

  console.log('langType Shery 2 ==> ', langId)


  const token = localStorage.getItem('token');
  const times = Date.now();
  if (userId && token) {
    config.params = {
      userId,
      token,
      times,
      langId,
      ...config.params
    };
  } else if (!userId && !token) {
    const token = 'sdddwddwdwdwwd';
    config.params = {
      times,
      langId,
      ...config.params
    };
  }

  // config.timeout = 300000; // 5 minutes

  return config;
});


const MAX_RETRIES = 3;
const RETRY_DELAY = 30 * 1000; // 30 seconds

// Some endpoints signal an invalid/expired session by returning HTTP 200 with an
// "Unauthorized" body (e.g. { status: 'error', message: 'Unauthorized' } or the
// bare string "Unauthorized") instead of a 401. Detect either shape here so the
// logout is handled once, centrally, for every API call.
const isUnauthorizedPayload = (data: unknown): boolean => {
  if (data === 'Unauthorized') {
    return true;
  }
  if (data && typeof data === 'object') {
    const payload = data as { status?: unknown; message?: unknown };
    return payload.status === 'error' && payload.message === 'Unauthorized';
  }
  return false;
};

// Log the user out and send them to the login screen via client-side
// navigation (no full page reload).
const logoutUnauthorized = () => {
  // Invalid/expired session (401 or "Unauthorized" body) — record before clear.
  captureLogout('session_expired');
  setGlobalState('sessionerror', 'Unauthorized');
  localStorage.clear();
  setGlobalState('loggedin', false);
  if (window.location.pathname !== '/login') {
    navigateTo('/login');
  }
};

// Response Interceptor with Retry Logic
Axios.interceptors.response.use(
  (response: AxiosResponse) => {
    // Catch "Unauthorized" payloads returned on a 2xx response and force logout.
    if (isUnauthorizedPayload(response.data)) {
      logoutUnauthorized();
      return Promise.reject(
        new axios.Cancel('Unauthorized - session expired')
      );
    }
    return response;
  },
  async (error: AxiosError) => {
    const config = error.config as AxiosRequestConfig & {
      __retryCount?: number;
      skipRetry?: boolean;
    };
    if (!config) {
      return Promise.reject(error);
    }

    // Force logout if the session is invalid (401) or the response carries an
    // "Unauthorized" body, regardless of HTTP status.
    if (
      error.response?.status === 401 ||
      isUnauthorizedPayload(error.response?.data)
    ) {
      logoutUnauthorized();
      return Promise.reject(error);
    }

    // Allow callers to explicitly disable retry for startup/UX-critical requests.
    if (config.skipRetry) {
      return Promise.reject(error);
    }

    // Do not retry for client errors (e.g., 400–499)
    const status = error.response?.status;
    if (status && status >= 400 && status < 500) {
      return Promise.reject(error);
    }

    // Track retry count
    config.__retryCount = config.__retryCount ?? 0;

    if (config.__retryCount < MAX_RETRIES) {
      config.__retryCount += 1;
      await new Promise((res) => setTimeout(res, RETRY_DELAY));
      return Axios(config);
    }

    return Promise.reject(error);
  }
);

// Ark Api Calls
export enum API {
  AddCase = '/addCase',
  GetCases = '/cases',
  FileUpload = '/fileUpload',
  TagsUpdate = '/tagsUpdate',
  Edit = '/edit',
  Docs = '/docsSQL',
  NetworkError = '/ediscoveryAPI.php',
  forgotPassAWS = '/forgotPassAWS',
  forgotPassCodeAWS = '/forgotPassCodeAWS',
  Files = '/filesSQL',
  eFiles = '/excelDocsNew',
  loginAWS = '/loginAWSSQL',
  registerAWS = '/signupAWSSQL',
  AWSauth = '/AWSauth',
  signupAWSCode = '/signupAWSCode',
  Search = '/advanceSearchFiles',
  CaseSettings = '/case-settings',
  changePassAWS = '/changePassAWS',
  Viewer = '/viewerSQL',
  Addtags = '/tagsUpdate',
  deleteCase = '/deleteCase',
  editCase = '/editCase',
  deleteDocs = '/deleteDocsSQL',
  DocType = 'docsGraphBardocType',
  columnSelection = 'columnSelection',
  VersionCheck = 'updateVersionSQL',
  GetConfig = 'formatList',
  updateUserFormat = 'updateUserFormat',
  fileUploadS3 = 'fileUploadS3MbotSQL',
  S3UploadPath = 'getS3BucketName',
  ResendVerificationCode = 'resendConfirmationCodeAWS',
  statusService = 'statusService',
  createService = 'createService',
  melasticsearch = 'elasticsearch',
  tagsMlrc = 'tagsSQL',
  postTags = 'postTagsSQL',
  docTypeMlrc = 'docTypeSQL',
  postType = 'postTypeSQL',
  fileProcess = 'fileProcessSQLNew', //fileProcessSQL
  postDeleteTags = 'postDeleteTagsSQL',
  statusServiceStaging = 'statusServiceStaging',
  createServiceStaging = 'createServiceStaging',
  getCommercials = 'getCommercials',
  updateStatusStopped = 'updateStatusStopped',
  fileUploadS3RealTime = 'fileUploadS3RealTimeSQL',
  docsRealTime = 'docsRealTimeSQL',
  addThumbsUp = 'addThumbsUp',
  viewThumbsUp = 'viewThumbsUpSQL',
  addThumbsUpNew = 'addThumbsUpLatest',
  updateThumbsUp = 'updateThumbsUpSQL',
  userDetails = 'userDetailsSQL',
  rules = 'rulesStaging',
  viewThumbsUpDownload = 'viewThumbsUpDownloadSQL',
  addThumbsUpLatestSQL = 'addThumbsUpLatestSQL',
  deleteThumbsUp = 'deleteThumbsUp',
  viewThumbsUpUsersSQL = 'viewThumbsUpUsersSQL',
  PDFListing = 'PIIviewerDocList',
  mlrcBedrock = 'Bedrock',
  userPreferences = 'userPreferences',
  realTimeTextProcess = 'realTimeTextProcess',
  imageUploadS3MbotSQL = 'imageUploadS3MbotSQL',
  imageMlrcSQL = 'imageSQL',
  imageProcessSQL = 'imageProcessSQL',
  getUserPref = 'getUserPref',
  deleteImgSQL = 'deleteImgSQL',
  updateStatusImgStopped = 'updateStatusImgStopped',
  addRulesStaging = 'addRulesStaging',
  updateRulesStaging = 'updateRulesStaging',
  viewThumbDelete = 'viewThumbDelete',
  readS3Json = 'readS3Json',
  realTimeImageSearch = 'realTimeImageSearch',
  statusServiceImage = 'statusServiceImage',
  adminIds = 'adminIds',
  aaGuidelines = 'aaGuidelines',
  getLoginData = 'getLoginData',
  LogAccessEmails = 'LogAccessEmails',
  getVersion = 'getVersion',
  getFeatures = 'getFeatures',
  searchType = 'searchType',
  rulesSemantic = 'rulesSemantic',
  claimFormOptions = 'claimFormOptions',
  userManagementListing = 'userManagementListing',
  userRoles = 'userRoles',
  updateRole = 'updateRole',
  deleteRules = 'deleteRules',
  checkRules = 'checkRules',
  addProductTag = 'addProductTag',
  smartSearch = 'smartSearch',
  smartSearchUpdateId = 'smartSearchUpdateId',
  smartSerachAccessEmails = 'smartSerachAccessEmails',
  smartSearchHistory = 'smartSearchHistory',
  getGoogleAccessToken = 'get-signed-url',
  OtherTagsArray = 'OtherTagsArray',
  tagActions = 'tagActions',
  isiSelectors = 'isiSelectors',
  USletterQuery = 'USletterQuery',
  USletterStatus = 'USletterStatus',
  getUSLetters = 'getUSLetters',
  getFDALetterDetail = 'getFDALetterDetail',
  libraryFileSelect = 'libraryFileSelect',
  tacticSummaryDetails = 'tacticSummaryDetails',
  statusServiceUS = 'statusServiceUS',
  createServiceUS = 'createServiceUS',
  Irs = 'Irs',
  getIRSOptions = 'getIRSOptions',
  getCases = 'getCases',
  getCaseDetails = 'getCaseDetails',
  getBreachDetails = 'getBreachDetails',
  updateCitationStatus = 'updateCitationStatus',
  fileUploadS3RealTimeSQLNew = 'fileUploadS3RealTimeSQLNew',
  activityLogs = 'activityLogs',
  claimDict = 'claimDict'
}

// Ark Api Calls
// export enum API {
//   AddCase = '/addCase',
//   GetCases = '/cases',
//   FileUpload = '/fileUpload',
//   TagsUpdate = '/tagsUpdate',
//   Edit = '/edit',
//   Docs = '/docsMlrcSQL',
//   NetworkError = '/ediscoveryAPI.php',
//   forgotPassAWS = '/forgotPassAWS',
//   forgotPassCodeAWS = '/forgotPassCodeAWS',
//   Files = '/filesMlrcSQL',
//   eFiles = '/excelDocsNew',
//   loginAWS = '/loginAWSSQL',
//   registerAWS = '/signupAWSSQL',
//   AWSauth = '/AWSauth',
//   signupAWSCode = '/signupAWSCode',
//   Search = '/advanceSearchFiles',
//   CaseSettings = '/case-settings',
//   changePassAWS = '/changePassAWS',
//   Viewer = '/viewerSQL',
//   Addtags = '/tagsUpdate',
//   deleteCase = '/deleteCase',
//   editCase = '/editCase',
//   deleteDocs = '/deleteDocsSQL',
//   DocType = 'docsGraphBardocType',
//   columnSelection = 'columnSelection',
//   VersionCheck = 'updateVersionSQL',
//   GetConfig = 'formatList',
//   updateUserFormat = 'updateUserFormat',
//   fileUploadS3 = 'fileUploadS3MbotSQL',
//   S3UploadPath = 'getS3BucketName',
//   ResendVerificationCode = "resendConfirmationCodeAWS",
//   statusService = 'statusService',
//   createService = 'createService',
//   melasticsearch = 'elasticsearch',
//   tagsMlrc = 'tagsMlrcSQL',
//   postTags = 'postTagsSQL',
//   docTypeMlrc = 'docTypeMlrcSQL',
//   postType = 'postTypeSQL',
//   fileProcess = 'fileProcessSQL',
//   postDeleteTags = 'postDeleteTagsSQL',
//   statusServiceStaging = 'statusServiceStaging',
//   createServiceStaging = 'createServiceStaging',
//   getCommercials= 'getCommercials',
//   updateStatusStopped = 'updateStatusStopped',
//   fileUploadS3RealTime = 'fileUploadS3RealTimeSQL',
//   docsRealTime = 'docsRealTimeSQL',
//   addThumbsUp = 'addThumbsUp',
//   viewThumbsUp = 'viewThumbsUpSQL',
//   addThumbsUpNew = 'addThumbsUpLatest',
//   updateThumbsUp = 'updateThumbsUpSQL',
//   userDetails = 'userDetailsSQL',
//   rules = 'rulesStaging',
//   viewThumbsUpDownload = 'viewThumbsUpDownloadSQL',
//   addThumbsUpLatestSQL = 'addThumbsUpLatestSQL',
//   deleteThumbsUp = 'deleteThumbsUp',
//   viewThumbsUpUsersSQL = 'viewThumbsUpUsersSQL',
//   PDFListing = 'PIIviewerDocList',
//   mlrcBedrock = 'mlrcBedrock',
//   userPreferences = 'userPreferences',
//   realTimeTextProcess= 'realTimeTextProcess',
//   imageUploadS3MbotSQL = 'imageUploadS3MbotSQL',
//   imageMlrcSQL = 'imageMlrcSQL',
//   imageProcessSQL = 'imageProcessSQL',
//   getUserPref = 'getUserPref',
//   deleteImgSQL = 'deleteImgSQL',
//   updateStatusImgStopped = 'updateStatusImgStopped',
//   addRulesStaging = 'addRulesStaging',
//   updateRulesStaging = 'updateRulesStaging',
//   viewThumbDelete = 'viewThumbDelete'
// }

export default Axios;
